<template>
  <div class="Consignee-tab" :class="{ 'px-8': !breakpointXs, 'px-2': breakpointXs }">
    <v-dialog v-model="dialog" max-width="750" persistent>
      <v-card :class="{ 'pa-7': !breakpointXs, 'pa-2': breakpointXs }">
        <v-card-title class="justify-space-between pa-0">
          <div :class="{ 'fs-25': !breakpointXs, 'fs-20': breakpointXs, 'fw-600': true }">
            Consignees
          </div>
          <v-btn v-if="!breakpointXs" icon @click="consigneeDialogHandler">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <div class="Consignee-tab__table pt-2">
          <div
            class="Consignee-tab__table__header d-sm-flex justify-space-between align-center"
            :class="{ 'text-center': breakpointXs }"
          ></div>
          <div class="Consignee-tab__table__body mt-5">
            <v-data-table :headers="tableHeaders" :items="consignees">
              <!-- select consignee -->
              <template v-slot:item.selectAction="{ item }">
                <v-btn color="lightPrimary" class="info font-weight-bold" dense @click="selectConsignee(item)"
                  >select</v-btn
                >
              </template>
              <!-- Select Consignee -->
            </v-data-table>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
//import { ValidationObserver } from "vee-validate";
//import TextField from "@/components/TextField";
//import * as AT from "../store/actionTypes";
import { SNACKBAR } from "@/store/actionTypes";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
export default {
  name: "ConsigneeModal",
  data() {
    return {
      isConsigneeTabFormLoading: false,
      dialog: true
    };
  },
  props: {
    consignees: {
      type: Array,
      default: () => {
        return {};
      }
    },
    clickedButtonFieldId: {
      type: Number,
      default: () => {
        return 0;
      }
    }
  },
  mixins: [commonMethodsMixin],
  methods: {
    selectConsignee(item) {
      this.$emit("selected-consignee", { selectedItem: item, clickedButtonFieldId: this.clickedButtonFieldId });
    },
    consigneeDialogHandler() {
      this.$emit("close-consignee-modal", false);
    },
    handleError(err) {
      var errorMessage = this.getErrorMessage(err);
      this.throwErrorMessage(errorMessage);
      return;
    },
    throwErrorMessage(errorMessage) {
      this.$store.dispatch(SNACKBAR, {
        color: "error",
        text: `${errorMessage}`
      });
      return;
    },
    getErrorMessage(err) {
      var errorMessage = "";
      if (err.data && err.data.message) {
        errorMessage = err.data.message;
      }
      if (err.data && err.data.errors) {
        errorMessage = [].concat.apply([], Object.values(err.data.errors));
      }
      return errorMessage;
    }
  },

  computed: {
    tableHeaders() {
      return [
        { text: "ID", value: "id", align: "center" },
        { text: "Name", value: "consignee_description", align: "center" },
        { text: "Action", value: "selectAction", align: "center" }
      ];
    }
  }
};
</script>
<style lang="scss">
.Consignee-tab {
  min-height: 350px;
  &__table {
    .v-data-table {
      background: transparent !important;
    }
  }
}
</style>
